// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1v8kE","col":"styles_col__1C8-l"};